<ng-container [formGroup]="formGroup">
  <mat-form-field color="accent" [appearance]="matFormFieldAppearance">
    <mat-label
      class="form-builder-input-label"
      [ngClass]="inputLabelStyleName"
      >{{ props.labelTranslation?.label | translate }}</mat-label
    >
    <ng-container [ngSwitch]="props.type">
      <ng-container *ngSwitchCase="'select'">
        <div class="relative">
          <mat-select
            [disableOptionCentering]="true"
            [hideSingleSelectionIndicator]="true"
            class="form-builder-select"
            panelClass="form-builder-select-overlay m-4"
            [ngClass]="inputStyleName"
            [formControlName]="props.key">
            <mat-option
              *ngFor="let option of props.selectOptions"
              [value]="option.value"
              role="none">
              {{ option.label }}
            </mat-option>
          </mat-select>

          <rd-shared-icon
            class="pointer-events-none absolute right-0 top-1 inline-block h-4 w-4"
            [iconSymbol]="'icon-select-chevron-down'"
            [iconTheme]="'link'">
          </rd-shared-icon>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <input
          class="form-builder-input"
          [ngClass]="inputStyleName"
          matInput
          [minlength]="props.minLength"
          [maxlength]="props.maxLength"
          [type]="props.type"
          [formControlName]="props.key"
          [placeholder]="props.placeholder | translate" />
      </ng-container>
    </ng-container>
    <mat-error
      class="form-builder-input-empty"
      [ngClass]="inputErrorEmptyStyleName"
      *ngIf="isEmpty()">
      {{ props.labelTranslation?.emptyErrorLabel | translate }}
    </mat-error>
    <mat-error
      class="form-builder-input-invalid"
      [ngClass]="inputErrorInvalidStyleName"
      *ngIf="isInvalidPattern()">
      {{ props.labelTranslation?.invalidPatternErrorLabel | translate }}
    </mat-error>
  </mat-form-field>
</ng-container>
